module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-Italic_11127f6f.82bf07e2.ttf";